function Juridico() {
    return 'Juridico'
}

export default Juridico